import Link from "next/link";
import { useRouter } from "next/router";
import DynamicIcon from "./dynamic-icon";
import ToggleHistory from "./toggle-history";
import IconHover from "./icon-hover";
import TimedTooltip from "./timed-tooltip";
import ComingSoonText from "./coming-soon-text";
import ToolTipContext from "../../contexts/tooltip-context";
import { useContext, useRef, useEffect } from "react";
import SidebarDropdown from "./sidebar-dropdown";
import Spinner from "./spinner";
import SideBarContext from "../../contexts/side-bar-context";
import { getCachedBusiness } from "../../lib/utils";


const NavMenuItem = ({ href, children, isNew, icon, onClick, tooltipCount, history,
  tooltipTitle, tooltipBody, newTab, className, handleEllipsis, isEllipsisOpen, closeEllipsis,
  dropdownContent, isEditing, tableId, handleChangeName, toggleEditing, isSaving, normalizeRoute=false }) => {


  const router = useRouter();
 const isActive = href ? (href === "/"
    ? router.pathname === href
    : router.pathname.includes(href) || router.asPath.includes(href)) ||
    router.asPath.startsWith(href) : false;

  const { activeTooltip } = useContext(ToolTipContext);
  const triggerRef = useRef(null);
  const inputRef = useRef(null);
  const {setIsSideBarOpen} = useContext(SideBarContext);

  useEffect(() => {
    if (isEditing) {
      const timeoutId = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);
      return () => clearTimeout(timeoutId);
    }
  }, [isEditing]);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleChangeName(tableId, e.currentTarget.value);
      e.currentTarget.blur();
    }
  };

  const toggleMobileSidebar = () => {
    {onClick && onClick();}
    if (window.innerWidth < 1024) {
      setIsSideBarOpen(false);
    }
  }

  return (
    <div ref={triggerRef} className="relative">
      {isEditing ? (
        <div className="flex items-center justify-between custom-text-grey-500 relative group lg:rounded-[8px] flex lg:max-w-[214px] max-w-[239px] w-full custom-bg-white-50 custom-shadow text-[12px] h-[35px] px-[16px]">
          <input
            ref={inputRef}
            className="w-full outline-none"
            type="text"
            defaultValue={children}
            onBlur={(e) => handleChangeName(tableId, e.currentTarget.value)}
            onKeyDown={handleKeyDown}
          />
          {isSaving ? (
            <Spinner size={14} />
          ) : (
            <DynamicIcon name='x' color='cursor-pointer' size={14} onClick={() => toggleEditing()} />
          )}
        </div>
      ) : (
        <div onClick={toggleMobileSidebar} className="relative group hover:custom-bg-grey-50 lg:rounded-[8px] flex lg:max-w-[214px] max-w-[239px] w-full">
          <Link href={normalizeRoute ? href : `/${getCachedBusiness()}${href}`} legacyBehavior>
            <a
              target={newTab ? "_blank" : "_self"}
              className={`${className} flex flex-shrink-0 custom-text-grey-800 justify-start items-center w-full text-[12px] h-[35px] px-[27px] gap-[12px] lg:rounded-[8px]
        ${isActive && "custom-bg-grey-50"}`}
            >
              {icon && <DynamicIcon name={icon} size="16" color="currentColor" />}
              <div className="flex items-center gap-[4px] w-full">
                <span
                  className={`${isActive ? 'poppins-medium custom-text-grey-800 leading-[16px]' : 'custom-text-grey-500  poppins-medium text-[12px] tracking-[0.5px]'} truncate max-w-[132px] whitespace nowrap `}
                >
                  {children}
                </span>
                {isNew && <ComingSoonText>New</ComingSoonText>}
              </div>
            </a>
          </Link>
          {history && (
            <IconHover additionalclasses="absolute right-2 top-[4px] z-[10] ">
              <ToggleHistory size={16} color="" />
            </IconHover>
          )}

          {handleEllipsis && (
            <>
              <IconHover onClick={handleEllipsis} additionalclasses="absolute right-2 top-[4px] z-[10] opacity-0 group-hover:opacity-100">
                <DynamicIcon name="ellipsis" size="16" color="custom-text-grey-800" />
              </IconHover>
              <SidebarDropdown additionalclasses="!min-w-[150px]" triggerRef={triggerRef} position="right" isOpen={isEllipsisOpen} toggleDropdown={closeEllipsis}>
                {dropdownContent}
              </SidebarDropdown>
            </>
          )}
        </div>
      )}

      {isNew && tooltipCount === activeTooltip && <TimedTooltip title={tooltipTitle} body={tooltipBody} additionalclasses="left-[195px] top-[0px]" />}
    </div>
  );
};

export default NavMenuItem;
